(function () {
  const selector = '[data-vanta-reviews-root]';
  const ratingSummarySelector = '.vanta-rating-summary[href="#vanta-product-reviews"]';

  function getText(root, key) {
    return root.dataset[key] || '';
  }

  function setStatus(root, message) {
    const status = root.querySelector('[data-vanta-reviews-status]');
    if (status) {
      status.textContent = message;
      status.hidden = !message;
    }
  }

  function clearList(root) {
    const list = root.querySelector('[data-vanta-reviews-list]');
    if (list) {
      list.textContent = '';
    }
  }

  function createStars(rating) {
    const stars = document.createElement('span');
    stars.className = 'vanta-product-review__stars';
    stars.setAttribute('role', 'img');
    stars.setAttribute('aria-label', `${rating} de 5 estrellas`);
    stars.textContent = '★'.repeat(rating) + '☆'.repeat(5 - rating);
    return stars;
  }

  function formatName(value) {
    const normalized = String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLocaleLowerCase('es-CO');

    if (!normalized) {
      return 'Cliente VANTA';
    }

    return normalized.replace(/(^|\s)([a-záéíóúñü])/g, (match) =>
      match.toLocaleUpperCase('es-CO')
    );
  }

  function formatLocationPart(value) {
    const lowercaseWords = ['de', 'del', 'la', 'las', 'los', 'y'];

    return String(value || '')
      .trim()
      .replace(/\s+/g, ' ')
      .toLocaleLowerCase('es-CO')
      .split(' ')
      .map((word, index) => {
        if (index > 0 && lowercaseWords.includes(word)) {
          return word;
        }

        if (/^[a-z]\.(?:[a-z]\.)+$/i.test(word)) {
          return word.toLocaleUpperCase('es-CO');
        }

        return word.replace(/(^|[-(])([a-záéíóúñü])/g, (_match, prefix, letter) =>
          `${prefix}${letter.toLocaleUpperCase('es-CO')}`
        );
      })
      .join(' ');
  }

  function createVerifiedBadge(root) {
    const badge = document.createElement('span');
    badge.className = 'vanta-product-review__verified-badge';

    const icon = document.createElement('span');
    icon.className = 'vanta-product-review__verified-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = '✓';

    const label = document.createElement('span');
    label.textContent = getText(root, 'verifiedLabel');

    badge.appendChild(icon);
    badge.appendChild(label);

    return badge;
  }

  function closeMediaViewer() {
    const viewer = document.querySelector('[data-vanta-review-media-viewer]');

    if (!viewer) {
      return;
    }

    viewer.classList.remove('is-visible');
    document.documentElement.classList.remove('vanta-review-media-open');

    window.setTimeout(() => {
      viewer.remove();
    }, 180);
  }

  function openMediaViewer(media) {
    closeMediaViewer();

    const viewer = document.createElement('div');
    viewer.className = 'vanta-review-media-viewer';
    viewer.dataset.vantaReviewMediaViewer = 'true';
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-label', media.altText || 'Foto de reseña');

    const backdrop = document.createElement('button');
    backdrop.className = 'vanta-review-media-viewer__backdrop';
    backdrop.type = 'button';
    backdrop.setAttribute('aria-label', 'Cerrar foto');
    backdrop.addEventListener('click', closeMediaViewer);

    const frame = document.createElement('div');
    frame.className = 'vanta-review-media-viewer__frame';

    const closeButton = document.createElement('button');
    closeButton.className = 'vanta-review-media-viewer__close';
    closeButton.type = 'button';
    closeButton.setAttribute('aria-label', 'Cerrar foto');
    closeButton.textContent = '×';
    closeButton.addEventListener('click', closeMediaViewer);

    const image = document.createElement('img');
    image.src = media.url;
    image.alt = media.altText || 'Foto de reseña';

    frame.appendChild(closeButton);
    frame.appendChild(image);
    viewer.appendChild(backdrop);
    viewer.appendChild(frame);
    document.body.appendChild(viewer);
    document.documentElement.classList.add('vanta-review-media-open');

    window.requestAnimationFrame(() => {
      viewer.classList.add('is-visible');
      closeButton.focus({ preventScroll: true });
    });
  }

  function renderReviewMedia(review) {
    const media = Array.isArray(review.media) ? review.media : [];

    if (media.length === 0) {
      return null;
    }

    const grid = document.createElement('div');
    grid.className = 'vanta-product-review__media-grid';

    media.forEach((item) => {
      if (!item || !item.url) {
        return;
      }

      const button = document.createElement('button');
      button.className = 'vanta-product-review__media-button';
      button.type = 'button';
      button.setAttribute('aria-label', 'Ver foto de la reseña');
      button.addEventListener('click', () => openMediaViewer(item));

      const image = document.createElement('img');
      image.src = item.url;
      image.alt = item.altText || 'Foto de reseña';
      image.loading = 'lazy';

      button.appendChild(image);
      grid.appendChild(button);
    });

    return grid.childElementCount > 0 ? grid : null;
  }

  function renderReview(root, review) {
    const article = document.createElement('article');
    article.className = 'vanta-product-review';

    const header = document.createElement('div');
    header.className = 'vanta-product-review__header';

    const identity = document.createElement('div');
    identity.className = 'vanta-product-review__identity';

    const nameRow = document.createElement('div');
    nameRow.className = 'vanta-product-review__name-row';

    const author = document.createElement('div');
    author.className = 'vanta-product-review__author';
    author.textContent = formatName(review.authorName);
    nameRow.appendChild(author);

    identity.appendChild(nameRow);

    if (review.city && review.department) {
      const location = document.createElement('div');
      location.className = 'vanta-product-review__location';

      const locationText = document.createElement('span');
      locationText.textContent = `${formatLocationPart(review.city)}, ${formatLocationPart(review.department)}`;

      const flag = document.createElement('span');
      flag.className = 'vanta-product-review__flag';
      flag.setAttribute('aria-label', 'Colombia');
      flag.setAttribute('role', 'img');
      flag.innerHTML = '<span></span><span></span><span></span>';

      location.appendChild(locationText);
      location.appendChild(flag);
      identity.appendChild(location);
    }

    if (root.dataset.showVerifiedBadge === 'true' && review.isVerifiedPurchase) {
      identity.appendChild(createVerifiedBadge(root));
    }

    header.appendChild(identity);
    header.appendChild(createStars(review.rating));
    article.appendChild(header);

    const body = document.createElement('p');
    body.className = 'vanta-product-review__body';
    body.textContent = review.body || '';
    article.appendChild(body);

    const mediaGrid = renderReviewMedia(review);

    if (mediaGrid) {
      article.appendChild(mediaGrid);
    }

    return article;
  }

  function renderSnippets(root, reviews) {
    const section = root.closest('.vanta-product-reviews');
    const snippets = document.querySelector(
      `[data-vanta-review-snippets][data-product-gid="${root.dataset.productGid}"]`
    ) || (section ? section.querySelector('[data-vanta-review-snippets]') : null);
    const snippetCount = Math.min(10, Math.max(1, Number(root.dataset.snippetReviewCount || '5')));
    const selectedReviews = reviews
      .filter((review) => review && review.body)
      .slice(0, snippetCount);

    if (!snippets) {
      return;
    }

    snippets.textContent = '';
    window.clearInterval(root.vantaReviewSnippetsTimer);

    if (selectedReviews.length === 0) {
      snippets.hidden = true;
      return;
    }

    selectedReviews.forEach((review, index) => {
      const card = document.createElement('article');
      card.className = 'vanta-review-snippet';
      card.dataset.vantaReviewSnippet = 'true';
      card.setAttribute('aria-hidden', index === 0 ? 'false' : 'true');

      const stars = createStars(review.rating);
      stars.classList.add('vanta-review-snippet__stars');

      const text = document.createElement('p');
      text.className = 'vanta-review-snippet__text';
      text.textContent = review.body.length > 118 ? `${review.body.slice(0, 118).trim()}...` : review.body;

      const author = document.createElement('span');
      author.className = 'vanta-review-snippet__author';
      author.textContent = formatName(review.authorName);

      card.appendChild(stars);
      card.appendChild(text);

      const meta = document.createElement('div');
      meta.className = 'vanta-review-snippet__meta';
      meta.appendChild(author);

      if (review.isVerifiedPurchase) {
        const badge = createVerifiedBadge(root);
        badge.classList.add('vanta-review-snippet__verified');
        meta.appendChild(badge);
      }

      card.appendChild(meta);
      snippets.appendChild(card);
    });

    if (selectedReviews.length > 1) {
      const previous = document.createElement('button');
      previous.className = 'vanta-review-snippet__nav vanta-review-snippet__nav--prev';
      previous.type = 'button';
      previous.setAttribute('aria-label', 'Reseña anterior');
      previous.textContent = '‹';

      const next = document.createElement('button');
      next.className = 'vanta-review-snippet__nav vanta-review-snippet__nav--next';
      next.type = 'button';
      next.setAttribute('aria-label', 'Siguiente reseña');
      next.textContent = '›';

      previous.addEventListener('click', () => showSnippet(root, -1));
      next.addEventListener('click', () => showSnippet(root, 1));

      snippets.appendChild(previous);
      snippets.appendChild(next);
      initSnippetSwipe(root, snippets);
    }

    snippets.hidden = false;
    snippets.dataset.activeIndex = '0';
  }

  function showSnippet(root, direction) {
    const section = root.closest('.vanta-product-reviews');
    const snippets = document.querySelector(
      `[data-vanta-review-snippets][data-product-gid="${root.dataset.productGid}"]`
    ) || (section ? section.querySelector('[data-vanta-review-snippets]') : null);
    const cards = snippets ? snippets.querySelectorAll('[data-vanta-review-snippet]') : [];

    if (!snippets || cards.length <= 1) {
      return;
    }

    const currentIndex = Number(snippets.dataset.activeIndex || '0');
    const nextIndex = (currentIndex + direction + cards.length) % cards.length;

    cards[currentIndex].setAttribute('aria-hidden', 'true');
    cards[nextIndex].setAttribute('aria-hidden', 'false');
    snippets.dataset.activeIndex = String(nextIndex);

    window.clearInterval(root.vantaReviewSnippetsTimer);
    rotateSnippets(root);
  }

  function initSnippetSwipe(root, snippets) {
    if (snippets.dataset.vantaSwipeInitialized === 'true') {
      return;
    }

    let startX = 0;
    let startY = 0;

    snippets.dataset.vantaSwipeInitialized = 'true';
    snippets.addEventListener(
      'touchstart',
      (event) => {
        startX = event.touches[0].clientX;
        startY = event.touches[0].clientY;
      },
      { passive: true }
    );

    snippets.addEventListener(
      'touchend',
      (event) => {
        const touch = event.changedTouches[0];
        const diffX = touch.clientX - startX;
        const diffY = touch.clientY - startY;

        if (Math.abs(diffX) > 38 && Math.abs(diffX) > Math.abs(diffY)) {
          showSnippet(root, diffX < 0 ? 1 : -1);
        }
      },
      { passive: true }
    );
  }

  function rotateSnippets(root) {
    const section = root.closest('.vanta-product-reviews');
    const snippets = document.querySelector(
      `[data-vanta-review-snippets][data-product-gid="${root.dataset.productGid}"]`
    ) || (section ? section.querySelector('[data-vanta-review-snippets]') : null);
    const cards = snippets ? snippets.querySelectorAll('[data-vanta-review-snippet]') : [];

    if (!snippets || cards.length <= 1) {
      return;
    }

    window.clearInterval(root.vantaReviewSnippetsTimer);
    const intervalSeconds = Math.min(10, Math.max(1, Number(root.dataset.snippetIntervalSeconds || '5')));
    root.vantaReviewSnippetsTimer = window.setInterval(() => showSnippet(root, 1), intervalSeconds * 1000);
  }

  function updatePagination(root, pagination) {
    const controls = root.querySelector('[data-vanta-reviews-pagination]');
    const previous = root.querySelector('[data-vanta-reviews-prev]');
    const next = root.querySelector('[data-vanta-reviews-next]');
    const page = root.querySelector('[data-vanta-reviews-page]');

    if (!controls || !previous || !next || !page) {
      return;
    }

    controls.hidden = pagination.totalPages <= 1;
    previous.disabled = pagination.page <= 1;
    next.disabled = pagination.page >= pagination.totalPages;
    page.textContent = `${pagination.page} / ${pagination.totalPages}`;
    page.classList.remove('is-changing');
    void page.offsetWidth;
    page.classList.add('is-changing');
  }

  function renderSuccess(root, payload) {
    const list = root.querySelector('[data-vanta-reviews-list]');
    const reviews = Array.isArray(payload.reviews) ? payload.reviews : [];
    const pagination = payload.pagination;
    const preferences = payload.preferences || {};

    clearList(root);

    if (!list || !pagination) {
      throw new Error('Invalid reviews response');
    }

    list.classList.remove('is-changing');
    root.dataset.snippetReviewCount = String(preferences.snippetReviewCount || 5);
    root.dataset.snippetIntervalSeconds = String(preferences.snippetIntervalSeconds || 5);

    if (reviews.length === 0) {
      setStatus(root, getText(root, 'emptyText'));
    } else {
      setStatus(root, '');
      renderSnippets(root, reviews);
      rotateSnippets(root);
      reviews.forEach((review) => list.appendChild(renderReview(root, review)));
      void list.offsetWidth;
      list.classList.add('is-changing');
    }

    updatePagination(root, pagination);
    root.dataset.currentPage = String(pagination.page);
  }

  async function loadReviews(root, page) {
    const previousController = root.vantaReviewsController;
    if (previousController) {
      previousController.abort();
    }

    const controller = new AbortController();
    root.vantaReviewsController = controller;

    setStatus(root, getText(root, 'loadingText'));
    root.classList.add('is-loading');

    const url = new URL(root.dataset.endpoint, window.location.origin);
    const params = new URLSearchParams({
      product_id: root.dataset.productGid,
      page: String(page),
      page_size: root.dataset.pageSize || '10',
    });
    url.search = params.toString();

    try {
      const response = await fetch(url.toString(), {
        headers: {
          Accept: 'application/json',
        },
        signal: controller.signal,
      });

      if (!response.ok) {
        throw new Error(`Reviews request failed: ${response.status}`);
      }

      const payload = await response.json();
      if (root.vantaReviewsController !== controller) {
        return;
      }

      renderSuccess(root, payload);
    } catch (error) {
      if (error.name === 'AbortError') {
        return;
      }

      clearList(root);
      setStatus(root, getText(root, 'errorText'));
    } finally {
      if (root.vantaReviewsController === controller) {
        root.classList.remove('is-loading');
      }
    }
  }

  function initRoot(root) {
    if (!root || root.dataset.vantaReviewsInitialized === 'true') {
      return;
    }

    root.dataset.vantaReviewsInitialized = 'true';
    root.dataset.currentPage = root.dataset.currentPage || '1';

    const previous = root.querySelector('[data-vanta-reviews-prev]');
    const next = root.querySelector('[data-vanta-reviews-next]');

    if (previous) {
      previous.addEventListener('click', () => {
        const page = Math.max(1, Number(root.dataset.currentPage || '1') - 1);
        loadReviews(root, page);
      });
    }

    if (next) {
      next.addEventListener('click', () => {
        const page = Number(root.dataset.currentPage || '1') + 1;
        loadReviews(root, page);
      });
    }

    loadReviews(root, Number(root.dataset.currentPage || '1'));
  }

  function initAll(scope) {
    const roots = (scope || document).querySelectorAll(selector);
    roots.forEach(initRoot);
  }

  function getScrollOffset() {
    const header = document.querySelector('.shopify-section-header-sticky, sticky-header, .header-wrapper');
    const headerHeight = header instanceof HTMLElement ? header.getBoundingClientRect().height : 0;

    return Math.max(16, headerHeight + 18);
  }

  function scrollToReviews(event) {
    const target = document.getElementById('vanta-product-reviews');

    if (!target) {
      return;
    }

    event.preventDefault();

    const top = target.getBoundingClientRect().top + window.scrollY - getScrollOffset();

    window.scrollTo({
      top: Math.max(0, top),
      behavior: 'smooth',
    });

    target.classList.remove('vanta-product-reviews--focused');
    window.setTimeout(() => {
      target.classList.add('vanta-product-reviews--focused');
    }, 320);

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#vanta-product-reviews');
    }
  }

  function initRatingLinks(scope) {
    const links = (scope || document).querySelectorAll(ratingSummarySelector);

    links.forEach((link) => {
      if (link.dataset.vantaSmoothScrollInitialized === 'true') {
        return;
      }

      link.dataset.vantaSmoothScrollInitialized = 'true';
      link.addEventListener('click', scrollToReviews);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAll(document);
      initRatingLinks(document);
    });
  } else {
    initAll(document);
    initRatingLinks(document);
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
    initRatingLinks(document);
  });

  document.addEventListener('shopify:section:unload', (event) => {
    event.target.querySelectorAll(selector).forEach((root) => {
      if (root.vantaReviewsController) {
        root.vantaReviewsController.abort();
      }
      window.clearInterval(root.vantaReviewSnippetsTimer);
      delete root.vantaReviewsController;
      delete root.vantaReviewSnippetsTimer;
      delete root.dataset.vantaReviewsInitialized;
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      closeMediaViewer();
    }
  });
})();
